import styled from 'styled-components';

export const RowList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const RowLabel = styled.span<{ $dimmed: boolean }>`
  color: ${({ $dimmed }) =>
    $dimmed
      ? 'var(--way-colors-contrastColorShades-70)'
      : 'var(--way-colors-primaryTextColor)'};
`;

export const SelectWrapper = styled.div`
  flex: 0 0 120px;
`;
